export default "__VITE_ASSET__CrADsdF0__"